// extracted by mini-css-extract-plugin
module.exports = {"container":"Ssgsew","separator":"AlYSyF mz-link"};